'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className", "children"];
/**
 * BrokerLeadCardContent
 *
 * Displays the details information in a column inside the BrokerLeadCardBody.
 */
var BrokerLeadCardContent = react.forwardRef(function (props, ref) {
  var styles = react.useStyles();
  var className = props.className,
    children = props.children,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, rest, {
    className: utils.cx('chakra-broker-lead-card__content', className),
    __css: styles.content
  }), children);
});
BrokerLeadCardContent.displayName = 'BrokerLeadCardContent';
exports.BrokerLeadCardContent = BrokerLeadCardContent;